import { useState } from "react";
import MonitorIcon from "@assets/svg/MonitorIcon";
import NotepadIcon from "@assets/svg/NotepadIcon";
import NotebookIcon from "@assets/svg/NotebookIcon";
import CheckSquareIcon from "@assets/svg/CheckSquareIcon";
import { Outlet, useSearchParams } from "react-router-dom";
import PlusCircleIcon from "@assets/svg/PlusCircleIcon";
import { NavLink } from "react-router-dom";

const stats = [
  {
    label: "All  jobs",
    value: 5,
    icon: <MonitorIcon />,
  },
  {
    label: "Live",
    value: 23,
    icon: <NotepadIcon />,
  },
  {
    label: "Draft",
    value: 7,
    icon: <NotebookIcon />,
  },
  {
    label: "Closed",
    value: 12,
    icon: <CheckSquareIcon />,
  },
  {
    label: "Total Applicants",
    value: 12,
    icon: <CheckSquareIcon />,
  },
];

const tabs = [
  {
    label: "View by Job",
    route: "by-job",
  },
  {
    label: "View by Candidate",
    route: "by-candidate",
  },
  {
    label: "View by Hiring Company",
    route: "by-hiring-company",
  },
];

const JobPageLayout = () => {
  const [searchText, setSearchText] = useState("");

  return (
    <div className="flex gap-4 w-full flex-grow min-h-0 flex-1">
      {/* Left section */}
      <div className="flex flex-col gap-3 flex-1 min-h-0">
        {/* Header container */}
        <div className="flex justify-between items-center gap-7 bg-white border rounded-lg px-4 py-2.5">
          <div className="flex flex-col">
            <div className="flex items-center gap-3">
              <div className="h-4 w-px bg-light-grey" />
              <span className="uppercase text-[8px] font-semibold tracking-wide text-[#858b93]">
                Recruitment workspace / Jobs
              </span>
            </div>
            <div className="flex items-center gap-3">
              <span className="font-semibold text-3xl">Jobs</span>
              <div className="h-4 w-px bg-light-grey" />
              <span className="text-xs font-medium text-[#515862]">
                Review every posted job, its latest activity and applicant
                response.
              </span>
            </div>
          </div>
          <NavLink
            to={"/job/create"}
            className="w-max bg-black rounded-md flex items-center justify-center text-white text-xs font-semibold py-2.5 h-max px-3 hover:bg-black gap-1"
          >
            <PlusCircleIcon fill="white" />
            Create new job
          </NavLink>
        </div>

        {/* Main container */}
        <div className="flex flex-col flex-1 min-h-0 items-center border rounded-lg bg-white">
          {/* Tabs container */}
          <div className="flex flex-col px-4 pt-5 w-full">
            <div className="flex items-center border-b gap-8">
              {tabs?.map((tab) => {
                return (
                  <NavLink
                    key={tab?.route}
                    to={tab?.route}
                    className={({ isActive }) =>
                      `font-semibold text-xs pb-1 ${
                        isActive
                          ? "text-charcoal border-primary border-b-2"
                          : "text-light-grey border-transparent"
                      }`
                    }
                  >
                    {tab?.label}
                  </NavLink>
                );
              })}
            </div>
          </div>
          <Outlet
            context={{
              searchText,
            }}
          />
        </div>
      </div>
      {/* Right section */}
      <div className="rounded-lg border bg-white w-[25%] h-max overflow-hidden">
        <div className="flex flex-col bg-black px-3 py-4">
          <span className="text-xs font-semibold text-white">Job overview</span>
          <span className="text-xss text-white">Current workspace</span>
        </div>
        {
          stats?.map((stat,statIndex)=>{
            return <div key={stat.label} className={`flex flex-col gap-2 py-3 px-5 ${statIndex !==0 ? 'border-t':''}`}>
              <span className="uppercase text-xss font-semibold text-light-black tracking-wider">{stat?.label}</span>
              <span className="font-semibold text-lg">{stat?.value}</span>
            </div>
          })
        }
      </div>
    </div>
  );
};

export default JobPageLayout;
